// removed by extract-text-webpack-plugin
module.exports = {"deviceConfigContentContainer":"_305rX318gYS87bHMMi443B","labelConatiner":"_3MmZ0nwHxj_rXGaD1hA_dB","configtabsContainer":"_2EzxiqxPX7WAU9JIyYX8Az","ant-tabs":"hLL-OH3I80MfxLaGac23L","ant-tabs-content":"_1NjDyvO-7zb90m8YHyNdTZ","contentBtnContainer":"_1hgW0MNRiqlPVjb67XtbzE","BtnItem":"_3RmdY1p1xxy6qPpw8gf-Ee"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DeviceConfig/Content.less
// module id = 1612
// module chunks = 0